import React from 'react';
import { connect } from 'react-redux';
import { Redirect, Route, withRouter } from 'react-router';
import { Layout } from 'antd';
import ScrollToTopOnMount from '../scroll_to_top_on_mount/ScrollToTopOnMount';
import SubnavTabs from '../subnav_tabs/SubnavTabs';
import RouteWithSubRoutes from '../route_with_sub_routes/RouteWithSubRoutes';
import { nullSafeGet } from '../../utils/DataAccessUtils';
import { BASE_VIEW_OPTIONS } from '../../utils/DataConstants';
import { savedFilterViewsRestCrudThunksForBuyer } from '../../thunks/saved_filter_views_thunks';
import {
	getAttentionDashboard,
	updateAttentionDashboard,
} from '../../thunks/attention_dashboard_thunks';
import { withUserType } from '../withUserType';
import { getRecordsForTargetCollection } from '../../reducers/standard_reducer_utils';
import { useWorkOrdersViewTabs, WORK_ORDERS_OVERVIEW_TABS_COLLECTION } from './useViewTabs';

const { Content } = Layout;

interface WorkOrdersOverviewPageProps {
	companyConfig: any;
	childRoutes: any[];
	defaultView: any;
	getWorkOrderDefaultView: () => Promise<any>;
	fetchWorkOrderViews: (
		params,
		targetCollectionName,
		pagination,
		sorting,
		filters,
		addToTargetCollection?
	) => Promise<any>;
	workOrderViews: any[];
	workOrderViewsLoading: boolean;
	attentionDashboards: any;
	saveAttentionDashboard: (entity: any) => Promise<any>;
}

const WorkOrdersOverviewPage = ({
	companyConfig,
	childRoutes,
	defaultView,
	getWorkOrderDefaultView,
	fetchWorkOrderViews,
	workOrderViews,
	workOrderViewsLoading,
	attentionDashboards,
	saveAttentionDashboard,
}: WorkOrdersOverviewPageProps): React.ReactElement => {
	const { loading, redirectTarget, tabs, handleTabChange, checkTabActive, tabsRightActions } =
		useWorkOrdersViewTabs({
			basePath: '/buyer/workOrders/overview',
			baseViewOptions: BASE_VIEW_OPTIONS,
			defaultView,
			workOrderViews,
			workOrderViewsLoading,
			attentionDashboards,
			saveAttentionDashboard,
			fetchWorkOrderViews,
			getWorkOrderDefaultView,
		});

	if (loading) return null;
	return (
		<div>
			<ScrollToTopOnMount />
			<div>
				<Route
					path="/buyer/workOrders/overview"
					exact
					render={() => <Redirect to={redirectTarget} />}
				/>
				<Content className="workOrdersPage" style={{ padding: '0 0.5em' }}>
					<div
						style={{
							margin: '0 -8px',
							padding: '24px',
							paddingBottom: 0,
							background: nullSafeGet('detail.config.theme.navblock', companyConfig),
							marginBottom: 8,
						}}
					>
						<div style={{ marginBottom: 24 }}>
							<h4
								style={{
									color: 'rgba(255, 255, 255, 0.9)',
									marginRight: 8,
									marginBottom: 0,
								}}
							>
								Work Orders
							</h4>
						</div>
						<SubnavTabs
							tabs={tabs}
							onChange={handleTabChange}
							isActive={checkTabActive}
							tabsRightActions={tabsRightActions}
							className="items-center justify-start"
						/>
					</div>
					{childRoutes.map((r, i) => (
						<RouteWithSubRoutes key={i} {...r} />
					))}
				</Content>
			</div>
		</div>
	);
};

const mapDispatchToProps = (dispatch, ownProps) => ({
	getWorkOrderDefaultView: () => getAttentionDashboard(dispatch, ownProps.userType),
	fetchWorkOrderViews: (
		params,
		targetCollectionName = WORK_ORDERS_OVERVIEW_TABS_COLLECTION,
		pagination = { current: 1, pageSize: 100 },
		sorting?,
		filters?,
		addToTargetCollection?
	) =>
		dispatch(
			savedFilterViewsRestCrudThunksForBuyer.read(
				params,
				targetCollectionName,
				pagination,
				sorting,
				filters,
				addToTargetCollection
			)
		),
	saveAttentionDashboard: (entity) => updateAttentionDashboard(dispatch, ownProps.userType, entity),
});

const mapStateToProps = (state) => ({
	companyConfig: state.company_config,
	defaultView: state.session.defaultView,
	workOrderViews: getRecordsForTargetCollection(
		state.saved_filter_views,
		WORK_ORDERS_OVERVIEW_TABS_COLLECTION
	),
	workOrderViewsLoading: nullSafeGet(
		`${WORK_ORDERS_OVERVIEW_TABS_COLLECTION}.fetching`,
		state.saved_filter_views
	),
	attentionDashboards: state.attention_dashboards.detail,
});

export default withRouter(
	withUserType(connect(mapStateToProps, mapDispatchToProps)(WorkOrdersOverviewPage))
);
